/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Pergi_NInputs */

const en_tut_pergi_n = /** @type {(inputs: Tut_Pergi_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The content is assembled from data, not guessed; one model-written summary paragraph is an extra, and the briefing is published even when that paragraph fails. If nothing important happened, no dialog interrupts you.`)
};

const id_tut_pergi_n = /** @type {(inputs: Tut_Pergi_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isi ringkasan disusun dari data, bukan ditebak; satu paragraf intisari yang ditulis model bersifat tambahan dan ringkasan tetap terbit walau paragraf itu gagal dibuat. Kalau tidak ada yang penting terjadi, tidak ada dialog yang mengganggu Anda.`)
};

/**
* | output |
* | --- |
* | "The content is assembled from data, not guessed; one model-written summary paragraph is an extra, and the briefing is published even when that paragraph fail..." |
*
* @param {Tut_Pergi_NInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_pergi_n = /** @type {((inputs?: Tut_Pergi_NInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Pergi_NInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_pergi_n(inputs)
	return en_tut_pergi_n(inputs)
});